import { useState, useEffect } from "react";
import Header from "../../components/Header"
import ContactsTable from "./ContactsTable"
import { getBrands } from "../../api/axios";
import useAuth from "../../hooks/useAuth";

const Contacts = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [emailDraft, setEmailDraft] = useState('');
  const [idBrandDraft, setIdBrandDraft] = useState('0');
  const [filters, setFilters] = useState({
    email: '',
    idBrand: '0',
  });
  const [brands, setBrands] = useState([]);

  const { auth } = useAuth();

  useEffect(() => {
    const fetchBrands = async () => {
      setIsLoading(true);

      try {
        const data = await getBrands({ auth });
        setBrands(Array.isArray(data.results) ? data.results : []);
        setError(null);
      } catch (fetchError) {
        setBrands([]);
        setError(fetchError);
      }

      setIsLoading(false);
    };

    fetchBrands();
  }, [auth]);

  const handleSubmit = (event) => {
    event.preventDefault();

    setFilters({
      email: emailDraft.trim(),
      idBrand: idBrandDraft,
    });
  };


  return (
    
    <>

      <Header />
              
      <div className="content">

      <h2 className="page_title">Destinatarios</h2>

        <div className="table_div">

          <div className="filters_div">

            <form action="" onSubmit={handleSubmit}>
              <ul>
                <li>
                  <label htmlFor="email">
                    <span>Email</span>
                    <input
                      id="email"
                      type="text"
                      value={emailDraft}
                      onChange={(event)=>{setEmailDraft(event.target.value)}}
                    />
                  </label> 
                </li>
                <li>
                  <label htmlFor="idBrand">
                    <span>Marca</span>
                    <select
                      id="idBrand"
                      value={idBrandDraft}
                      onChange={(event)=>{setIdBrandDraft(event.target.value)}}
                    >
                      <option value="0">Todas</option>
                      {!isLoading && brands.map((brand) => (
                        <option key={brand.id} value={brand.id}>{brand.name}</option>
                      ))}
                    </select>
                  </label> 
                </li>
                <li>
                  <button className="button-outline" type="submit">Buscar</button>
                </li>
              </ul>
            </form>
            {error ? <p className="c baja">No se pudieron cargar las marcas.</p> : null}

          </div>

          <ContactsTable params={filters} />

        </div>

      </div>

    </>

    
  )
}

export default Contacts
